import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
// eslint-disable-next-line no-restricted-imports
import { useLocation } from 'react-router'
import { useMemo } from 'react'
import { currentUserResponseAtom, currentUserWithRefresh } from './auth.atoms'

const loggedOutPath = '/login'

export function useCurrentUserResource() {
  const loadingData = useAtomValue(currentUserResponseAtom)
  if (loadingData.state !== 'hasData') return
  return loadingData.data
}

export function useCurrentUserRedirectResource() {
  const loadingData = useAtomValue(currentUserResponseAtom)
  const reFreshUser = useSetAtom(currentUserWithRefresh)
  const location = useLocation()
  return useMemo(() => {
    const returnData = {
      data: undefined,
      ...loadingData,
      reFreshUser,
      redirectUrl: '',
    }
    if (
      loadingData.state === 'hasError' &&
      location.pathname !== loggedOutPath
    ) {
      returnData.redirectUrl = loggedOutPath
    } else if (
      loadingData.state === 'hasData' &&
      location.pathname === loggedOutPath
    ) {
      returnData.redirectUrl = '/'
    }
    return returnData
  }, [reFreshUser, loadingData, location.pathname])
}
